import React, { useState } from 'react';
import { Form, Row, Col, Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * Form that checks for violation by reference number
 *
 * @component - ReferenceData
 * @parentComponent - ViolationCheck
 */

interface Props {
  dataCheck: (data: ReferenceData) => void;
  clearDirtyState?: () => void;
  setDirtyState: () => void;
  setReferenceNo: boolean;
}

interface ReferenceData {
  referenceNo: string;
}

const ReferenceForm = (props: Props) => {
  const { t } = useTranslation();

  const [referenceNo, setReferenceNo] = useState('');
  const setReferenceHandler = (event: any) => {
    setReferenceNo(event.target.value);
  };

  const checkData = () => {
    props.dataCheck({
      referenceNo: referenceNo,
    });
    if (props.clearDirtyState) {
      props.clearDirtyState();
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') checkData();
  };

  const resetForm = () => {
    setReferenceNo('');
    props.setDirtyState();
  };

  return (
    <Container className="ReferenceForm fadeIn">
      <Form as={Row} className="formControl">
        <Form.Group as={Col} md={4} className="formGroup">
          <Form.Label className="label">{t('ReferenceForm.label')}</Form.Label>
          <Form.Control size="sm" value={referenceNo} onChange={setReferenceHandler} onKeyPress={handleKeyPress} />
        </Form.Group>
        <Form.Group as={Col} md={4} className="formGroup">
        </Form.Group>
        <Form.Group as={Col} md={4} className="buttonControl">
          <Button onClick={resetForm} variant="outline-success" className="resetBtn" size="sm">
            {t('ReferenceForm.reset')}
          </Button>
          <Button onClick={checkData} variant="success" size="sm">
            {t('ReferenceForm.button')}
          </Button>
        </Form.Group>
      </Form>
    </Container>
  );
};

export default ReferenceForm;
